//Reset data
export const RESET = "COMPLAINER_UPDATE_RESET"

export const SET_IS_UPDATED = "COMPLAINER_UPDATE_SET_IS_CREATE"
export const SET_NOT_UPDATED = "COMPLAINER_UPDATE_SET_NOT_CREATE"
//Loading
export const SET_TOGGLE_LOADING = "COMPLAINER_UPDATE_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "COMPLAINER_UPDATE_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "COMPLAINER_UPDATE_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "COMPLAINER_UPDATE_SET_MESSAGE"
export const SET_IS_SUCCESS = "COMPLAINER_UPDATE_SET_IS_SUCCESS"
export const SET_IS_ERROR = "COMPLAINER_UPDATE_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "COMPLAINER_UPDATE_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "COMPLAINER_UPDATE_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "COMPLAINER_UPDATE_SET_HIDE_MESSAGE"

//Data
export const SET_UPDATE = "COMPLAINER_UPDATE_SET_UPDATE"
export const SET_CURRENT_ITEM = "COMPLAINER_UPDATE_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "COMPLAINER_UPDATE_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "COMPLAINER_UPDATE_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "COMPLAINER_UPDATE_SET_HIDE_MODAL"


export const SET_MODAL = "COMPLAINER_UPDATE_SET_MODAL"
export const SET_MODAL_CONTENT = "COMPLAINER_UPDATE_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "COMPLAINER_UPDATE_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "COMPLAINER_UPDATE_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "COMPLAINER_UPDATE_SET_MODAL_TYPE"